export const LOGIN_USER_WITH_CREDENTIALS = 'LOGIN_USER_WITH_CREDENTIALS';
export const LOGIN_USER_WITH_OAUTH = 'LOGIN_USER_WITH_OAUTH';
export const START_OAUTH = 'START_OAUTH';
export const LOGIN_USER_WITH_TOKEN = 'LOGIN_USER_WITH_TOKEN';
export const LOGIN_ANALYTICS_IDENTIFY = 'LOGIN_ANALYTICS_IDENTIFY';
